import React, { useEffect } from 'react'
import { useAccountTypes } from '../../providers'
import { useCustomizeDashboard } from '../../Customizations/customizationContext/CustomizeDashboardContext'
import { customErrorAnalytics } from '../../analytics'
import {
  ComponentLookupObj,
  CustomizeDataObj,
} from '../../Customizations/types'
import { LobShell, PartialOutageNotice, StaleDataNotice } from '../Shared'
import { useHostServices } from '../../HostServices'
import { Cds } from './Cds'
import { IRAs } from './IRAs'
import { InterestChecking } from './InterestChecking'
import { Savings } from './Savings'

export const bankAccountComponents: ComponentLookupObj = {
  CHECKING: <InterestChecking key="InterestCheckingCard" />,
  SAVINGS: <Savings key="SavingsCard" />,
  CD: <Cds key="CdsCard" />,
  IRA: <IRAs key="IRAsCard" />,
}

function getSortedAccountTypeComponents(
  customizeData: CustomizeDataObj,
  type: string[],
): React.ReactElement[] {
  return customizeData.accountTypes
    .filter(account => type.includes(account.lob))
    .sort((a, b) => a.order - b.order)
    .map(account => bankAccountComponents[account.name])
}

export const BankAccounts: React.FC = () => {
  const {
    isBankOutage,
    isBankUser,
    hasActiveDepositAccounts,
    hasStaleBankAccounts,
  } = useAccountTypes()
  const { log } = useHostServices()

  const [{ customizeApiData }] = useCustomizeDashboard()

  const sortedBankAccountCards = customizeApiData
    ? getSortedAccountTypeComponents(customizeApiData, ['DEPOSIT'])
    : null

  useEffect((): void => {
    if (isBankOutage) {
      customErrorAnalytics('Bank Outage')
    }
  }, [isBankOutage])

  useEffect(() => {
    if (hasStaleBankAccounts) {
      log.track('received-always-on-deposits')
    }
  }, [])

  return (
    <>
      {(isBankUser && hasActiveDepositAccounts) || isBankOutage ? (
        <LobShell header="Bank Accounts" customizeTriggerLob="bank">
          {hasStaleBankAccounts && (
            <StaleDataNotice dataTestId="stale-deposit-notice" />
          )}
          {isBankOutage ? (
            <PartialOutageNotice lob="bank" />
          ) : (
            sortedBankAccountCards
          )}
        </LobShell>
      ) : null}
    </>
  )
}
